import { RefObject, useCallback } from 'react';

export const useScrollToBottom = (targetRef: RefObject<HTMLElement>) => {
  const scrollToBottom = useCallback(
    (options: ScrollToOptions = {}) => {
      if (targetRef.current) {
        targetRef.current.scrollTo({
          behavior: 'smooth',
          top: targetRef.current.scrollHeight,
          ...options
        });
      }
    },
    [targetRef]
  );

  return { scrollToBottom };
};
